import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectUI from '../../../widgets/form/InputSelectUI'

const UpdateDepositModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  //
  dsraFromLoan, onDsraChange, dsraError,
  booleanList
}) =>
  <ModalFormUI
    context={context}
    titleLabel=''
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputSelectUI name='dsraFromLoan' value={dsraFromLoan} required={true}
      label='DSRA from Loan' optionList={booleanList}
      onChange={onDsraChange} error={dsraError}
    /> 
  </ModalFormUI>

export default UpdateDepositModalUI
